import request from '@/utils/request'
import host from '@/api/base/host'

// 礼品卡
const card = host.path('dev', { dev: 'v1/my' })

export default {
  getGiftCardById(data) {
    return request({
      url: card('getGiftCardById'),
      method: 'post',
      data
    })
  },
  useGiftCard(data) {
    return request({
      url: card('useGiftCard'),
      method: 'post',
      data
    })
  },
  saveCardMessage(data) {
    return request({
      url: card('saveCardMessage'),
      method: 'post',
      data
    })
  },
  getUseGiftCardData(data) {
    return request({
      url: card('getUseGiftCardData'),
      method: 'post',
      data
    })
  }
}
